@if (advertisement().region || advertisement().city) {
  <mat-chip class="location-chip">{{ advertisement().city?.name ?? advertisement().region?.name }}</mat-chip>
}
@if (categories().get(advertisement().category_id); as category) {
  <mat-chip highlighted class="category-chip">{{ category.name }}</mat-chip>
}
